import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const ErrorIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M11.0039 15.004H13.0039V17.004H11.0039V15.004ZM11.0039 7.00403H13.0039V13.004H11.0039V7.00403ZM11.9939 2.00403C6.47391 2.00403 2.00391 6.48403 2.00391 12.004C2.00391 17.524 6.47391 22.004 11.9939 22.004C17.5239 22.004 22.0039 17.524 22.0039 12.004C22.0039 6.48403 17.5239 2.00403 11.9939 2.00403ZM12.0039 20.004C7.58391 20.004 4.00391 16.424 4.00391 12.004C4.00391 7.58403 7.58391 4.00403 12.0039 4.00403C16.4239 4.00403 20.0039 7.58403 20.0039 12.004C20.0039 16.424 16.4239 20.004 12.0039 20.004Z"
                fill="#E2004F"
            />
        </SvgIcon>
    );
};
